import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LineFloatingButton from '../../components/feature/LineFloatingButton';
import SuccessHeroSection from './components/SuccessHeroSection';
import SuccessCasesGrid from './components/SuccessCasesGrid';
import SuccessCTASection from './components/SuccessCTASection';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const successJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  url: `${SITE_URL}/success`,
  name: '東京シニア婚活 成婚事例 | 縁結び 和はは',
  description: '東京のシニア婚活相談所「縁結び和はは」の成婚事例をご紹介。50代・60代・70代の方々が東京シニア婚活で幸せをつかんだリアルなエピソード。婚活東京シニアの実際の成婚実績を公開中。',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ホーム', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: '成婚事例', item: `${SITE_URL}/success` },
    ],
  },
  about: {
    '@type': 'ItemList',
    name: '東京シニア婚活成婚事例一覧',
    description: '50代・60代・70代の成婚エピソード',
  },
};

export default function SuccessPage() {
  return (
    <>
      <SeoHead
        title="東京シニア婚活成婚事例 | 縁結び 和はは 婚活相談所"
        description="東京のシニア婚活相談所「縁結び和はは」の成婚事例。婚活東京シニア専門で50代・60代・70代の方が新しい幸せをつかんだエピソードを紹介。東京シニア婚活で成婚した実際のお客様の声。"
        keywords="東京 シニア 婚活, 成婚事例 東京, シニア婚活成功, 50代成婚, 60代再婚, 70代婚活成婚"
        path="/success"
        jsonLd={successJsonLd}
      />
      <Navbar />
      <main>
        <SuccessHeroSection />
        <SuccessCasesGrid />
        <SuccessCTASection />
      </main>
      <Footer />
      <LineFloatingButton />
    </>
  );
}
